import { GruppedCatalogItem } from 'lib/types';

export function isNotNull<T>(value: T | null | undefined): value is T {
  return value != null;
}

export function getRecommendedItemsDummy(): GruppedCatalogItem[] {
  return [];
}
